import { useFormContext } from "rectangular-forms";

import IconVectorRightBlue from "../../../images/icon_button_users_blue.svg";
import LoadingSpinner from "../../../images/loading_gray.gif";
import LoadingGray from "../../../images/loading_gray.gif";
import { DivLabelButton, MainButton } from "./InputTemplateStyles";

export const SaveButton = (props: any) => {
  const { formSaveStatus, formLoadStatus } = useFormContext();
  const isProcessing = formSaveStatus === "PROCESSING";
  const { isLoading, isDisableRuc, isDisabled } = props;
  return (
    <>
      {formLoadStatus === "SUCCESS" && (
        <MainButton
          type="submit"
          disabled={isProcessing || isDisableRuc || isDisabled}
          width={props.width}
          height={props.height}
          fontSize={props.fontSize}
          backgroundColor={props.backgroundColor}
          isDisabled={isDisabled}
        >
          <DivLabelButton marginRight={props.label}>
            {props.label && props.label}
          </DivLabelButton>
          {isProcessing || isLoading ? (
            <img
              src={
                props.backgroundColor === "#002E6C"
                  ? LoadingGray
                  : LoadingSpinner
              }
              className="icon"
              alt=""
            />
          ) : (
            props.iconRight && (
              <div>
                <img
                  src={IconVectorRightBlue}
                  className="icon-height-width"
                  alt=""
                />
              </div>
            )
          )}
        </MainButton>
      )}
    </>
  );
};
